import $ from 'jquery';
import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { LanguageSelector } from '@bingads-webui-campaign/language-selector';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { AdGroup } from '@bingads-webui-campaign/campaign-ui-schemas';
import { customizedInlineEditTemplate } from '@bingads-webui-campaign/summary-grid-helper';

const config = globalContext.require('component/config/index');
const Permissions = config.get('Permissions');

function getLanguages() {
  let languages = AdGroup.properties.Language.enum;
  if (!Permissions.IsSimplifiedChineseLanguageEnabledInMultipleLanguage) {
    languages = _.without(languages, 'SimplifiedChinese');
  }

  if (!Permissions.IsAdsGlobalizationPhase1Enabled) {
    languages = _.without(languages, 'Greek', 'Polish', 'Bulgarian', 'Croatian', 'Czech', 'Estonian', 'Hungarian', 'Latvian', 'Lithuanian', 'Maltese', 'Romanian', 'Slovak', 'Slovenian');
  }

  if (!Permissions.IsAdsGlobalizationPhase2Enabled) {
    languages = _.without(languages, 'Turkish', 'Serbian', 'Bosnian', 'Albanian', 'Macedonian', 'Icelandic');
  }

  if (!Permissions.IsAdsGlobalizationPhase6Enabled) {
    languages = _.without(languages, 'Hebrew', 'Arabic', 'Russian');
  }

  if (!Permissions.IsAdsGlobalizationPhase2JapanEnabled) {
    languages = _.without(languages, 'Japanese');
  }

  if (!Permissions.IsAdsGlobalizationPhase9Enabled) {
    languages = _.without(languages, 'Hindi', 'Malay', 'Thai', 'Indonesian', 'Tagalog');
  }

  if (!Permissions.IsAdsGlobalizationPhase9VIEnabled) {
    languages = _.without(languages, 'Vietnamese');
  }

  // make 'All' the first language
  languages = _.without(languages, 'All', 'None');

  if (Permissions.IsDomesticSimplifiedChineseEnabled) {
    languages = ['SimplifiedChinese'];
  }

  return languages;
}

export class LanguageInlineEditView extends DeterministicView {
  initialize({ selectedLanguage, i18n, campaignHasLanguage }) {
    super.initialize({ selectedLanguage, i18n });

    this.options = {
      languages: getLanguages(),
      i18n,
      withInheritOption: campaignHasLanguage,
      selectedLanguage,
      i18nStrings: {
        SaveWarning: '',
        Description: i18n.getString('AdGroup_MarketLanguage'),
      },
    };
    this.languageSelector = new LanguageSelector(this.options);
    this.setChild('subEditView', this.languageSelector);
  }

  get events() {
    return {
      'click .btn-primary': 'save',
      'click .btn-default': 'cancel',
    };
  }

  get template() {
    return ({ model }) => customizedInlineEditTemplate({ model, i18n: this.options.i18n });
  }

  save() {
    this.trigger('save', { selectedLanguage: this.languageSelector.getSelectedLanguage() });
  }

  cancel() {
    this.trigger('close');
  }

  setErrors(errors) {
    if (errors && !_.isEmpty(errors) && _.isObject(errors)) {
      $('.grid-error-list').removeClass('hide');
      $('.grid-error-message').html(errors[_.keys(errors)[0]]);
    } else {
      $('.grid-error-list').addClass('hide');
    }
  }
}
